import React, { useEffect, useState, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";

export const SelectImageDialog = ({ open, onClose, onSelectImage }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    if (open) {
      const fetchImages = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/condition/allBMname`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setImages(response.data);
        } catch (error) {
          console.error("Failed to fetch images:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchImages();
    }
  }, [open, token]);

  const handleImageClick = (bmname) => {
    onSelectImage(bmname); // Pass the selected image name back to the parent
    onClose(); // Close the dialog
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Select an Image</DialogTitle>
      <DialogContent>
        {loading ? (
          <Backdrop sx={{ zIndex: 1400 }} open={loading}>
            <CircularProgress size={80} />
          </Backdrop>
        ) : (
          <Box display="grid" gridTemplateColumns="repeat(5, 1fr)" gap={2}>
            {images.map((bmname) => (
              <Box
                key={bmname}
                onClick={() => handleImageClick(bmname)}
                sx={{
                  cursor: "pointer",
                  borderRadius: "8px",
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "#FFFFFF00",
                  "&:hover": {
                    opacity: 0.8,
                    borderColor: darkMode
                      ? getColors.appBarBgLight
                      : getColors.appBarBgDark,
                  },
                }}
              >
                <img
                  src={require(`../../assets/condition/${bmname}.png`)}
                  alt={bmname}
                  style={{
                    width: "120px",
                    height: "120px",
                  }}
                />
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};
